import apiUtils from "../../../../utils/apiUtils";
import {
  isMerchantOnboardingStage,
  type MerchantOnboardingStage,
} from "../../shared/types/merchant-onboarding.types";

export interface MerchantOnboardingStatus {
  stage: MerchantOnboardingStage;
  is_onboarding_completed: boolean;
}

interface MerchantOnboardingStatusResponse {
  stage: string;
  is_onboarding_completed: boolean;
}

const getStatus = async (): Promise<MerchantOnboardingStatus> => {
  const response = await apiUtils.getData<MerchantOnboardingStatusResponse>(
    "/v1/local-merchant/onboarding-status",
    "Unable to determine merchant onboarding status",
  );

  if (
    !isMerchantOnboardingStage(response.stage) ||
    typeof response.is_onboarding_completed !== "boolean"
  ) {
    throw new Error("Merchant onboarding status is invalid");
  }

  return {
    stage: response.stage,
    is_onboarding_completed: response.is_onboarding_completed,
  };
};

/** Feature API facade for the authenticated merchant onboarding-status endpoint. */
export const merchantOnboardingApi = {
  getStatus,
};
